/* eslint-disable dot-notation */
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DialogConsultaPredictusComponent } from '@app/modules/parceiro/components';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import {
  IVendedor,
  TIPO_VENDEDOR
} from '@app/modules/vendedor/models/vendedor.model';
import { VendedorService } from '@app/modules/vendedor/services/vendedor.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { validateCnpj, validateCpf } from '@app/shared/utils';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  CustomValidators,
  DomainService,
  ErroMessages,
  IErroMessages,
  Pattern,
  TokenService,
  UserService,
  ViggoCoreCustomInputComponent
} from 'viggo-sistemas-core-web';

@Component({
  selector: 'fast-form-info-pessoais',
  templateUrl: './fast-form-info-pessoais.component.html',
  providers: [UserService, ParceiroService, VendedorService]
})
export class FastFormInformacoesPessoaisComponent implements OnInit {
  @ViewChildren(ViggoCoreCustomInputComponent)
  elementsInputs: QueryList<ViggoCoreCustomInputComponent>;

  public domainId = '';

  parceiros: IParceiro[];

  blocked_actions = false;

  form: UntypedFormGroup;

  displayMessage = {};

  user_id: string;

  @Input() entity: IVendedor;
  @Output() onCancelClick = new EventEmitter();
  @Output() onLoadParceiro = new EventEmitter<IParceiro>();
  @Output() onClearIdFromEntityParceiro = new EventEmitter<void>();
  tipoVendedor: { label: string; value: string }[];
  loadingParceiro = false;
  cpfCnpjMask = '000.000.000-00*';

  messages = {
    nome_razao_social: {
      required: 'O nome é requerido.',
      maxlength: 'O nome deve ter no maximo 60 caracteres.',
      minlength: 'O nome é requerido.',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    apelido_nome_fantasia: {
      required: 'Nome fantasia é obrigatório',
      maxlength: 'Este nome é muito longo.',
      minlength: 'Este nome é muito curto.',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    cpf_cnpj: {
      repeated: 'Informação já cadastrada.',
      mask: 'Valor inválido.',
      required: 'O CPF/CNPJ é obrigatório',
      pattern: 'Este CPF/CNPJ é inválido.',
      maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
      duplicate: 'O CPF/CNPJ já esta cadastrado',
      validateCPF: 'Este CPF é inválido.',
      validateCNPJ: 'Este CNPJ é inválido.'
    },
    rg_insc_est: {
      pattern: 'Este valor é inválido.',
      maxlength: 'O campo deve conter no máximo 20 caracteres.',
      duplicate: 'Rg/Insc.Est já existe na base de dados',
      existSpecialChar: 'Valor inválido, não aceita pontuação!',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    }
  };

  focusElement: any;
  inputElementDtNasc: boolean;
  ID_FIELD_DTNASC = 'field-data-nascimento';
  ID_DTPICKER_NASC = 'dtPickerToggleDtNasc';

  constructor(
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar,
    public router: Router,
    protected tokenService: TokenService,
    protected formBuilder: UntypedFormBuilder,
    public userService: UserService,
    protected domainService: DomainService,
    protected parceiroService: ParceiroService,
    protected vendedorService: VendedorService
  ) {
    this.tipoVendedor = Utils.enumToLisObjet(TIPO_VENDEDOR);
  }

  ngOnInit(): void {
    this.domainId = this.tokenService.getDomain().id;
    const { entity } = this;
    // pega a data de hoje
    this.parceiroService
      .getEntities(this.tokenService.getDomain().id)
      .subscribe(
        parceiros => {
          this.parceiros = parceiros.map(p => ({
            ...p,
            cpf_cnpj: p.cpf_cnpj.trim()
          }));
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
    const today = new Date();
    this.form = this.formBuilder.group({
      nome_razao_social: [
        entity.parceiro.nome_razao_social,
        [Validators.required, Validators.maxLength(60), Validators.minLength(1)]
      ],
      apelido_nome_fantasia: [
        entity.parceiro.apelido_nome_fantasia,
        [Validators.required, Validators.maxLength(60), Validators.minLength(1)]
      ],
      cpf_cnpj: [entity.parceiro.cpf_cnpj, [Validators.required]],
      rg_insc_est: [
        entity.parceiro.rg_insc_est,
        [
          Validators.pattern(Pattern.patternInscEstadual()),
          Validators.maxLength(20)
        ]
      ],
      user: [entity.parceiro.user, [CustomValidators.typeIs('object')]],
      data_nascimento: [
        entity.parceiro.data_nascimento,
        [
          CustomValidators.date(
            new Date(entity.parceiro.data_nascimento),
            today
          ),
          CustomValidators.isEmptyValue()
        ]
      ],
      tipo: [entity.tipo || this.tipoVendedor[0].value, [Validators.required]]
    });
    if (this.entity.id) {
      this.form.controls.cpf_cnpj.disable({ emitEvent: false });
    }
    this.user_id = this.form.value.user ? this.form.value.user.id : undefined;

    this.form.controls.cpf_cnpj.valueChanges.subscribe(vl => {
      if (vl.toString().length <= 11) {
        this.cpfCnpjMask = '000.000.000-00*';
      } else {
        this.cpfCnpjMask = '00.000.000/0000-00';
      }
      this.removeValidatorMask();
      this.validar();
    });
  }

  removeValidatorMask() {
    const { cpf_cnpj } = this.form.controls;
    if (cpf_cnpj.hasError('mask')) cpf_cnpj.setErrors(null);
  }

  validar() {
    const cpfCnpjValue = this.form.controls.cpf_cnpj.value;
    if (cpfCnpjValue.toString().length <= 11) {
      if (validateCpf(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
        this.form.updateValueAndValidity();
      }
    } else {
      if (validateCnpj(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
        this.form.updateValueAndValidity();
      }
    }
  }

  /**
   * @description
   * Reune as informações que são relevantes para o vendedor
   * diretamente do formulário fazendo um tratamento e retornandoas.
   * @returns {IVendedor} informações da parte de identificação
   */
  getValues() {
    let vendedor: IVendedor = { ...this.form.value };
    // limpa as informações com null
    vendedor = Utils.clearObject(vendedor);
    delete vendedor.tipo;
    return vendedor;
  }

  public checkRgInscEstadual(): void {
    const rgInsc = this.form.controls.rg_insc_est;

    if (rgInsc.invalid) return;
    const rgInscValue: string = rgInsc.value.replace(/[^a-zA-Z0-9 ]/g, '');

    this.parceiroService
      .getEntitiesByParams(
        `rg_insc_est=${rgInscValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe(
        (parceiro: IParceiro) => {
          if (parceiro[0] && parceiro[0].id) {
            this.form.controls.rg_insc_est.setErrors({ duplicate: true });
            this.form.updateValueAndValidity();
            return {} as IParceiro;
          }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  /**
   * Abre um dialog que contém a consulta na predictus
   */
  openDialogConsultaPredictus() {
    this.loadingParceiro = true;
    const cpfCnpjValue: string = this.form.controls.cpf_cnpj.value.replace(
      /\D/g,
      ''
    );

    this.domainService.consultaPredictus(cpfCnpjValue).subscribe(
      (response: any) => {
        response.contatos = [];
        this.loadingParceiro = false;
        this.matDialog
          .open(DialogConsultaPredictusComponent, {
            data: { data: response, usaCnae: false },
            panelClass: ['transparent-dialog']
          })
          .afterClosed()
          .subscribe((res: IParceiro) => {
            if (res) {
              this.onLoadParceiro.emit({
                ...res,
                id: this.entity?.id
              });
              this.form.patchValue({
                apelido_nome_fantasia: res.apelido_nome_fantasia || null,
                nome_razao_social: res.nome_razao_social || null,
                rg_insc_est: res.rg_insc_est || null,
                data_nascimento: res.data_nascimento || null
              });
            }
          });
      },
      (err: HttpErrorResponse) => {
        this.loadingParceiro = false;
        this.displayError(err, false);
      }
    );
  }

  public checkCpfCnpj(): void {
    const cpfCnpj = this.form.controls.cpf_cnpj;

    if (
      !cpfCnpj.value ||
      cpfCnpj.value === undefined ||
      cpfCnpj.value.length < 11 ||
      cpfCnpj.hasError('validateCPF') ||
      cpfCnpj.hasError('validateCNPJ')
    )
      return;
    const cpfCnpjValue: string = cpfCnpj.value.replace(/\D/g, '');
    this.loadingParceiro = true;

    this.parceiroService
      .getEntitiesByParams(
        `cpf_cnpj=${cpfCnpjValue}&include=user`,
        this.tokenService.getDomain().id
      )
      .pipe(
        map(parceiros =>
          parceiros.length
            ? { ...parceiros[0], cpf_cnpj: parceiros[0].cpf_cnpj.trim() }
            : ({ contatos: [], enderecos: [] } as IParceiro)
        ),
        mergeMap(parceiro => {
          if (!parceiro || !parceiro.id || parceiro.id === this.entity.id)
            return of(parceiro);
          return this.vendedorService.getEntity(parceiro.id).pipe(
            map(ent => {
              if (ent && ent.id) {
                this.form.controls.cpf_cnpj.setErrors({ duplicate: true });
                this.form.updateValueAndValidity();
                return { contatos: [], enderecos: [] } as IParceiro;
              }
              return parceiro;
            }),
            catchError(() => of(parceiro))
          );
        })
      )
      .subscribe(
        (parceiro: IParceiro) => {
          this.loadingParceiro = false;
          if (!parceiro || !parceiro.id) {
            this.form.controls.rg_insc_est.setValue('');
            this.onClearIdFromEntityParceiro.emit();
            return;
          } else {
            this.onLoadParceiro.emit(parceiro);
            this.form.patchValue({
              apelido_nome_fantasia: parceiro.apelido_nome_fantasia || null,
              nome_razao_social: parceiro.nome_razao_social || null,
              rg_insc_est: parceiro.rg_insc_est || null,
              user: parceiro.user || null,
              user_id: parceiro.user_id || null,
              data_nascimento: parceiro.data_nascimento || null
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.loadingParceiro = false;
          this.displayError(err);
        }
      );
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  getUser(): unknown {
    if (this.form.get('user').value) {
      return this.form.get('user').value.id;
    }
    return null;
  }

  getTipo(): unknown {
    return this.form.get('tipo').value;
  }

  getDataNascimento(): unknown {
    return this.form.get('data_nascimento').value;
  }

  onFocus(event, input?: boolean) {
    if (input !== undefined && input !== null)
      if (document.activeElement.id === this.ID_FIELD_DTNASC) {
        this.inputElementDtNasc =
          event?.target?.id === document.activeElement.id;
      } else {
        this.inputElementDtNasc = false;
      }
    if (event) {
      this.focusElement = event.target?.id;
    } else {
      this.focusElement = null;
    }
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = true) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.checkError();
  }
}
